import { render } from "./TestAccelerometerData.vue?vue&type=template&id=18e01ef2"
import script from "./TestAccelerometerData.vue?vue&type=script&lang=js"
export * from "./TestAccelerometerData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__